import DispatchablePayload from './DispatchablePayload';

let _lastId = 0;

export class GazePoint {
	constructor(source) {
		if (source) {
			this.s_x = source.s_x;
			this.s_y = source.s_y;
			this.p_x = source.p_x;
			this.p_y = source.p_y;
			this.fov = source.fov;
		}
	}
}

class TrackerActivity extends DispatchablePayload {
	constructor(source) {
		super(source);

		/**
		 * Identifier provided in response to TrackerMessageInitialize.
		 */
		this.instance_id = undefined;

		/**
		 * Location inside the tour. Sphere name, page URL...
		 */
		this.location = undefined;

		/**
		 * How many locations (spheres) did the user travel to reach this point. Starts at 1 for the initial location
		 * and should be increased on each location change (even when returning to previously visited locations)
		 */
		this.journey_step = undefined;

		/**
		 * True if presentation was in VR mode during this span.
		 */
		this.in_vr_mode = undefined;

		/**
		 * How many milliseconds ago has the recorded period had started relative to the moment it was sent to the API
		 */
		this.started_ago_ms = undefined;

		/**
		 * How many milliseconds ago has the recorded period had ended relative to the moment it was sent to the API.
		 */
		this.ended_ago_ms = undefined;

		/**
		 * How many milliseconds has user been active during the reported period (<= span_ms).
		 * The "resolution" of activity can be determined by the client. Eg. if user moves the mouse,
		 * they can be marked as being active in that 500ms (or 1s) span of time.
		 */
		this.user_active_ms = undefined;

		/**
		 * How many ms has the app window been focused during the reported period (<= span_ms).
		 */
		this.window_focused_ms = undefined;

		/**
		 * Hash of hotspot_name => ms. Tracking full attention during the recorded period.
		 * On web, full attention is defined as foreground hotspot being inside the bounds of a centered rectangle,
		 * 50% the width and 50% the height of the screen.
		 */
		this.focused_attention = undefined;

		/**
		 * Hash of hotspot_name => ms, tracking peripheral attention during the recorded period.
		 * On web, this is generated by forground hotspots that are outside the rectangle defined in "focused_attention".
		 */
		this.peripheral_attention = undefined;

		/**
		 * Hash of hotspot_name => ms, tracking the time a background hotspot was on screen, doesn't matter where.
		 */
		this.background_attention = undefined;

		/**
		 * An array of GazePoint records (x,y, fov) where the visitor's gaze was pointed during the interval.
		 * The values are in normalized radial degrees, x is [-180..180], y is [-90..90], fov is field of view (90 by default).
		 * The points are successive in time, as they are recorded.
		 * @type {GazePoint[]}
		 */
		this.gaze_points = undefined;

		/**
		 * Interval between recorded gaze points. Usually between 50ms and 1000ms.
		 */
		this.gaze_interval_ms = undefined;

		// Client only
		_lastId++;
		this.id = 'A' + _lastId;
		this.started_at = new Date();
		this.ended_at = null;

		if (source) {
			Object.assign(this, source);
		}
	}

	prepareForDispatch(now) {
		this.started_ago_ms = now - this.started_at;
		this.ended_ago_ms = now - this.ended_at;
	}

	toString() {
		return `${this.id} (${this.journey_step}. ${this.location})`;
	}
}

export default TrackerActivity;
